import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Newslettter from "../../components/Newslettter";
import "../../assets/css/privacy.css";

const Privacy = () => {
	return (
		<>
			<Header />
			{/* privacy sec starts here */}
			<section className="privacy-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-10">
							<div className="content-wrapper">
								<h2>Privacy And Policy</h2>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magna aliqua.
									Nunc eget lorem dolor sed viverra ipsum nunc aliquet bibendum.
									Lorem ipsum dolor sit amet consectetur. Sed vulputate odio ut
									enim blandit. Malesuada nunc vel risus commodo viverra
									maecenas accumsan. Nibh sed pulvinar proin gravida. Arcu dui
									vivamus arcu felis bibendum ut tristique et egestas. Sed
									adipiscing diam donec adipiscing. Sit amet cursus sit amet
									dictum sit amet justo donec. In iaculis nunc sed augue lacus.
									Pellentesque habitant morbi tristique senectus et netus et
									malesuada. Condimentum id venenatis a condimentum vitae sapien
									pellentesque. Lacus luctus accumsan tortor posuere ac ut
									consequat. Maecenas pharetra convallis posuere morbi. Molestie
									nunc non blandit massa enim nec dui nunc.
								</p>
								<p>
									Vulputate sapien nec sagittis aliquam malesuada bibendum. Sit
									amet purus gravida quis blandit turpis cursus in. Tortor vitae
									purus faucibus ornare suspendisse sed. Est ante in nibh mauris
									cursus mattis molestie. Ultrices in iaculis nunc sed. Mauris
									in aliquam sem fringilla ut morbi tincidunt augue. Nam libero
									justo laoreet sit amet cursus. Pharetra magna ac placerat
									vestibulum lectus mauris ultrices. Arcu non odio euismod
									lacinia at quis risus sed. Praesent semper feugiat nibh sed.
								</p>
								<p>
									Amet luctus venenatis lectus magna fringilla urna. Dictum at
									tempor commodo ullamcorper a lacus vestibulum. Amet purus
									gravida quis blandit turpis cursus. Sed cras ornare arcu dui
									vivamus arcu felis bibendum. Orci nulla pellentesque dignissim
									enim. At consectetur lorem donec massa sapien faucibus et
									molestie. Turpis egestas integer eget aliquet nibh praesent
									tristique magna. Pellentesque habitant morbi tristique
									senectus et netus et. Amet nisl suscipit adipiscing bibendum
									est ultricies integer quis auctor. Ullamcorper dignissim cras
									tincidunt lobortis feugiat vivamus at augue. Sit amet cursus
									sit amet dictum sit amet. Nisi quis eleifend quam adipiscing.
									Sed cras ornare arcu dui. Nulla posuere sollicitudin aliquam
									ultrices sagittis orci a.
								</p>
								<p>
									Diam sollicitudin tempor id eu nisl nunc. Lectus nulla at
									volutpat diam. Condimentum mattis pellentesque id nibh tortor
									id. Magna eget est lorem ipsum dolor sit. Id neque aliquam
									vestibulum morbi. Urna cursus eget nunc scelerisque viverra
									mauris in aliquam sem. Viverra tellus in hac habitasse platea
									dictumst vestibulum. Nullam ac tortor vitae purus faucibus
									ornare suspendisse sed nisi. Risus viverra adipiscing at in
									tellus. Pellentesque diam volutpat commodo sed egestas
									egestas. Ut placerat orci nulla pellentesque dignissim. Elit
									scelerisque mauris pellentesque pulvinar. Nibh venenatis cras
									sed felis eget velit aliquet sagittis. Purus in mollis nunc
									sed. Molestie ac feugiat sed lectus vestibulum mattis
									ullamcorper velit sed. Diam phasellus vestibulum lorem sed
									risus ultricies. Id consectetur purus ut faucibus. Nulla
									facilisi morbi tempus iaculis urna id. Amet porttitor eget
									dolor morbi non arcu risus quis varius. Velit laoreet id donec
									ultrices tincidunt.
								</p>
							</div>
						</div>
						<div className="col-lg-1"></div>
					</div>
				</div>
			</section>
			{/* privacy sec ends here */}
			<Newslettter />
			<Footer />
		</>
	);
};

export default Privacy;
